import { useParams } from 'react-router-dom';
import { usePurchase } from '@/hooks/usePurchases';
import { useOperations } from '@/hooks/useOperations';
import LoadingState from '@/components/common/LoadingState';
import ErrorState from '@/components/common/ErrorState';
import LegacyForm from './PurchaseFormPage';
import LegacyDetail from './PurchaseDetailPage';
import LegacyList from './PurchasesListPage';
import PurchaseRecordForm from './PurchaseRecordForm';
import PurchaseRecordDetail from './PurchaseRecordDetail';
import PurchaseRecordsList from './PurchaseRecordsList';
import PurchaseLifecycleActions from '@/components/purchases/PurchaseLifecycleActions';
export function PurchaseFormRoute() {
  const { id } = useParams();
  const query = usePurchase(id);
  if (id && query.isLoading) return <LoadingState />;
  if (query.error) return <ErrorState message={query.error.message} onRetry={query.refetch} />;
  if (id && !query.data) return <ErrorState message="Purchase not found" />;
  if (query.data?.is_deleted || query.data?.archived_at || query.data?.is_voided)
    return <PurchaseRecordDetail purchase={query.data} />;
  return query.data?.workflow_mode === 'record_only' || !id ? (
    <PurchaseRecordForm key={id || 'new'} purchase={query.data} />
  ) : (
    <div className="space-y-4">
      <p className="rounded-xl border border-amber-500/30 p-4 text-sm">
        Legacy stock order: its receiving workflow still posts inventory. Use Add purchase for a
        separate record without stock effects.
      </p>
      <LegacyForm />
    </div>
  );
}
export function PurchaseDetailRoute() {
  const { id } = useParams();
  const query = usePurchase(id);
  if (query.isLoading) return <LoadingState />;
  if (query.error) return <ErrorState message={query.error.message} onRetry={query.refetch} />;
  if (!query.data) return <ErrorState message="Purchase not found" />;
  return query.data.workflow_mode === 'record_only' ||
    query.data.is_deleted ||
    query.data.archived_at ? (
    <PurchaseRecordDetail purchase={query.data} />
  ) : (
    <div className="space-y-4">
      <div className="flex flex-wrap justify-end gap-3">
        <span className="text-sm text-muted-foreground">
          Legacy stock order · receiving still changes inventory
        </span>
        <PurchaseLifecycleActions purchase={query.data} />
      </div>
      <LegacyDetail />
    </div>
  );
}
export function PurchasesRoute() {
  const ops = useOperations();
  if (ops.isLoading) return <LoadingState />;
  if (ops.error) return <ErrorState message={ops.error.message} onRetry={ops.refetch} />;
  return ops.data?.modules.purchases === 1 ? <PurchaseRecordsList /> : <LegacyList />;
}
